export default function BrandingFooter() {
  return (
    <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-50">
      <p className="text-[#52525B]/70 text-xs font-light">
        Enabled by <a href="https://bingelabs.in/" target="_blank" rel="noopener noreferrer" className="hover:text-[#A1A1AA] transition-colors">Bingelabs</a>
      </p>
    </div>
  );
}
